import { requestPDServer } from '@/utils/fetchResponse';
import Cookies from 'js-cookie';
const myBaseUrl = process.env.VUE_APP_BASE_API;
// const userInfo = store.getters['socket/getUserInfo'](platformUserId);

function setCookie() {
    const activeUser = localStorage.getItem('activeUser');
    if (activeUser) {
      const user = JSON.parse(activeUser);
      Cookies.set('tld-token', user.pdToken);
    }
}

// 获取所有国家
// https://talkytimes.com/platform/autocomplete/all-countries
export const getAllCountries = (data) => {
    return requestPDServer('/platform/autocomplete/all-countries', data);
}

// 搜索推荐用户
// https://talkytimes.com/platform/account/search
// "filters":{"ageTo":90,"ageFrom":18,"gender":null},// 年龄范围,gender:国家编号,ageTo:年龄上限,ageFrom:年龄下限
// "limit":12,// 限制数量
// "page":2// 页码
export const getSearchRecommendUsers = (data) => {
    return requestPDServer('/platform/account/search', data);
}

// 添加喜欢
// https://talkytimes.com/platform/social-action/like
// idInterlocutor
export const addLike = (data) => {
    return requestPDServer('/platform/social-action/like', data);
}

// 获取列表中用户是否喜欢
// https://talkytimes.com/platform/connection/get
// {"idsInterlocutor":[76433217,124100802,113021497,121919399,123601388,122205374,104531459,124509091,124934659,109354063,123794255,118799814]}
export const getConnection = (data) => {
    return requestPDServer('/platform/connection/get', data);
}